var React = require('react');

function OrderNowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.83252 3.46888V12.5334C3.83252 13.0785 4.36389 13.4248 4.80148 13.1635L12.55 8.52592C12.9289 8.29931 12.9289 7.70293 12.55 7.47631L4.80148 2.83874C4.36389 2.57743 3.83252 2.92376 3.83252 3.46888Z","stroke":"#0A2240","strokeWidth":"1.00189","strokeMiterlimit":"10"}));
}

OrderNowInline.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = OrderNowInline;

OrderNowInline.default = OrderNowInline;
